var path = '/components/navigation/components/breadcrumb/views/component.tpl.html';
var html = "<div class=\"breadcrumbs\">\n    <span ng-repeat=\"elem in vm.breadcrumb\" class=\"elem\" ng-class=\"{last:$last,first:$first}\">\n        <a ng-click=\"vm.goToElem(elem)\" ng-if=\"!$last\" ng-bind-html=\"vm.sce.trustAsHtml(elem.label)\"></a>\n        <span ng-if=\"!$last\" class=\"separator\"><span class=\"fal fa-chevron-right fa-small\"></span>\n        </span><span ng-if=\"$last\" ng-bind-html=\"vm.sce.trustAsHtml(elem.label)\"></span>\n    </span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navigation/components/breadcrumb/views/component.tpl.html
// module id = 2008
// module chunks = 1